import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { StockPeriodFilter, StockPeriodReport } from '../interfaces/inventory/stockPeriod.interface';

const params = (institutionId: string, f: StockPeriodFilter) => ({
  institutionId, from: f.from, to: f.to,
  ...(f.storeId ? { storeId: f.storeId } : {}), ...(f.categoryId ? { categoryId: f.categoryId } : {}),
});

export const StockPeriodReportService = {
  report: async (institutionId: string, f: StockPeriodFilter): Promise<StockPeriodReport> =>
    (await axios.get(ENDPOINTS.STOCK_PERIOD_REPORT.REPORT, { params: params(institutionId, f) })).data,
  xlsx: async (institutionId: string, f: StockPeriodFilter): Promise<Blob> =>
    (await axios.get(ENDPOINTS.STOCK_PERIOD_REPORT.XLSX, { params: params(institutionId, f), responseType: 'blob' })).data,
  pdf: async (institutionId: string, f: StockPeriodFilter): Promise<Blob> =>
    (await axios.get(ENDPOINTS.STOCK_PERIOD_REPORT.PDF, { params: params(institutionId, f), responseType: 'blob' })).data,
};
